module.exports = __webpack_public_path__ + "static/media/costcoLogistics_s.31f49a59.png";